export const getCategoryProducts = async (categoryId: string, page = 1) => {
  // FIXME: This place
  const response = await fetch(
    `/api/bigcommerce/catalog/getCategoryProducts/?category_id=${categoryId}&page=${page}`
  )
  const { data } = await response.json()
  return data
}
